import React, { useCallback, useContext } from "react";
import { Suspense, useEffect, useState } from "react";
import {
  Notifications,
  NotificationsRead,
  NotificationsRemove,
  NotificationType,
} from "./service";
import moment from "moment";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { useDispatch } from "react-redux";
import InfiniteScroll from "react-infinite-scroll-component";
import { TostMsg } from "../../../App";
import debounce from "lodash.debounce";
import { setNotificationRequestData } from "../../../Services/Redux/DataTransferToAnother";
import { NotificationCount } from "../../../Services/Global-Services/GlobalServices";
const ComponentLoader = React.lazy(() =>
  import("../../../Shared/Sidebar/ComponentLoader")
);
const defaultImage = "/images/placeholder_profile.png";

function Notification() {
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  let searchValue = "";
  const toster = useContext(TostMsg);
  let SystemAlerts = JSON.parse(localStorage.getItem("SystemAlerts") || "{}");
  const [masterSystemAlertData, setMasterSystemAlertData] = useState([]);
  const [NotificationNotificationTypeId, SetNotificationNotificationTypeId] =
    useState([]);
  const history = useHistory();
  const dispatch = useDispatch();
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  const [Isloading, setIsloading] = useState(false);
    const [IsNotificationloading, setIsNotificationloading] = useState(false);
  const [notificationsList, setNotificationsList] = useState([]);
  const [isFetching, setIsFetching] = useState(false);
  const [noData, setNoData] = useState([]);
  useEffect(() => {
    notifications(false);
    notificationsType();
    GetMasterSystemAlertList("Notification_header", 1);
    GetMasterSystemAlertList("Notification_Unavailable", 2);
    window.scrollTo(0, 0);
  }, []);


  async function GetMasterSystemAlertList(message, type) {
    SystemAlerts?.filter((msg) => {
      if (msg?.Name == message && type == 0) {
        toster.current.success(msg?.Desc);
      } else if (msg?.Name == message && type == 1) {
        setMasterSystemAlertData(msg?.Desc)
      }
      else if (msg?.Name == message && type == 2) {
        setNoData(msg?.Desc);
      }
    });
  }

  const notifications = async (reset = false) => {
    setIsNotificationloading(true);
    setIsFetching(true);
    const params = {
      customerId: userDetails?.EmpId,
      userNotificationId: 0,
      IsRead: 2,
      pageNumber: reset ? 1 : page,
      pageSize: 25,
      search: searchValue,
    };
    try {
      const response = await Notifications(params);
      let newNotifications = response?.Data?.NotificationList;
      if (reset == true) {
        setNotificationsList(newNotifications);
        setIsNotificationloading(false);
      } else {
        if (newNotifications?.length === 0) {
          setHasMore(false);
          setIsNotificationloading(false);
        } else {
          setIsNotificationloading(false);
          setNotificationsList((data) => [...data, ...newNotifications]);
          setPage((p) => p + 1);
        }
      }
    } catch {
      setIsNotificationloading(false);
    } finally {
      setIsNotificationloading(false);
      setIsFetching(false);
    }
  };

  const notificationsType = async () => {
    try {
      let NotificationTypeList = await NotificationType();
      SetNotificationNotificationTypeId(NotificationTypeList?.Data);
      setIsloading(false);
    } catch {
      setIsloading(false);
    }
  };

  const handleChange = (event) => {
    setPage(1);
    setNotificationsList([]);
    handleSearch(event.target.value);
  };

  const handleSearch = useCallback(
    debounce((value) => {
      searchValue = value;
      notifications(false);
    }, 300),
    []
  );

  const notificationsRead = async (event) => {
    let IsReadNotification = false;
    if (event?.IsRead === true) {
      IsReadNotification = false;
    } else {
      IsReadNotification = event?.IsRead;
    }
    // setIsloading(true);
    const params = {
      customerId: userDetails?.EmpId,
      userNotificationId: event?.UserNotificationId,
      IsReadAll: IsReadNotification,
    };
    try {
      await NotificationsRead(params);
      dispatch(setNotificationRequestData('hitNotification'));
      setPage(1);
      setNotificationsList([]);
      notifications(true);
      setIsloading(false);
    } catch {
      setIsloading(false);
    }
  };

  const AllNotificationRead = async () => {
    setIsloading(true);
    const params = {
      customerId: userDetails?.EmpId,
      userNotificationId: 0,
      IsReadAll: true,
    };
    try {
      await NotificationsRead(params);
      setPage(0);
      localStorage.setItem("NotificationCount", JSON.stringify(0));
      dispatch(setNotificationRequestData('hitNotification'));
      setNotificationsList([]);
      notifications(true);
      setIsloading(false);
    } catch {
      setIsloading(false);
    }
  };



  const notificationsRemove = async (event) => {
    setIsloading(true);
    const params = {
      userNotificationId: event?.UserNotificationId,
    };
    try {
      await NotificationsRemove(params);
      notifications(true);
      GetMasterSystemAlertList("Notification_removed", 0);
      setIsloading(false);
    } catch {
      setIsloading(false);
    }
  };
  const configClass = [
    "is-purple",
    "is-green",
    "is-warning",
    "is-rounded",
    "is-success",
    "is-danger",
    "is-info",
    "is-unread",
  ];

  const FunctionNavitageToPage = (event) => {
    const commentBody = event?.NotificationBody;

    // Use regex to extract the ticket number after '#'
    const match = commentBody.match(/#([A-Za-z0-9]+)/);
    const ticketId = match ? match[1] : null;
    switch (event?.NotificationTypeId) {
      case 101:
        window.open(`/Dashboard`, "_blank");
        break;
      case 102:
        window.open(`/Dashboard`, "_blank");
        break;
      case 103:
        window.open(`/Dashboard`, "_blank");
        break;
      case 104:
        window.open(`/MyAssessment`, "_blank");
        break;
      case 105:
        window.open(`/Gallery`, "_blank");
        break;
      case 106:
        window.open(`/Dashboard`, "_blank");
        break;
      case 107:
        window.open(`/Articles`, "_blank");
        break;
      case 108:
        window.open(`/MyAssessment`, "_blank");
        break;
      case 109:
        window.open(`/MyAssessment`, "_blank");
        break;
      case 110:
        window.open(`/MyAssessment`, "_blank");
        break;
      case 111:
        window.open(`/MyAssessment`, "_blank");
        break;
      case 112:
        window.open(`/MyAssessment`, "_blank");
        break;
      case 112:
        window.open(`/MyAssessment`, "_blank");
        break;
      case 113:
        window.open(`/MyAssessment`, "_blank");
        break;
      case 114:
        window.open(`/Announcement`, "_blank");
        break;
      case 115:
        window.open(`/Celebrations`, "_blank");
        break;
      case 116:
        window.open(`/Award/Detail/${event?.GUID}`, "_blank");
        break;
      case 117:
        window.open(`/LeaveDashboard`, "_blank");
        break;
      case 118:
        window.open(`/LeaveDashboard`, "_blank");
        break;
      case 119:
        window.open(`/LeaveDashboard`, "_blank");
        break;
      case 120:
        window.open(`/LeaveDashboard`, "_blank");
        break;
      case 121:
        window.open(`/WfhDashboard`, "_blank");
        break;
      case 122:
        window.open(`/WfhDashboard`, "_blank");
        break;
      case 123:
        window.open(`/WfhDashboard`, "_blank");
        break;
      case 124:
        window.open(`/WfhDashboard`, "_blank");
        break;
      case 125:
        window.open(`/Ticket`, "_blank");
        break;
      case 126:
        window.open(`/LeaveDashboard`, "_blank");
        break;
      case 127:
        window.open(`/Notification`, "_blank");
        break;
      case 128:
        window.open(`/WfhDashboard`, "_blank");
        break;
      case 129:
        window.open(`/WfhDashboard`, "_blank");
        break;
      case 130:
        window.open(`/LeaveDashboard`, "_blank");
        break;
      case 131:
        window.open(`/LeaveDashboard`, "_blank");
        break;
      case 132:
        window.open(`/Ticket/Detail/${ticketId ? ticketId : event?.ReferenceGUID}`, "_blank");
        break;
      case 133:
        window.open(`/Ticket/Detail/${ticketId ? ticketId : event?.ReferenceGUID}`, "_blank");
        break;
      case 134:
        window.open(`/Ticket/Detail/${ticketId ? ticketId : event?.ReferenceGUID}`, "_blank");
        break;
      case 135:
        window.open(`/Ticket/Detail/${ticketId ? ticketId : event?.ReferenceGUID}`, "_blank");
        break;
      case 136:
        window.open(`/Ticket/Detail/${ticketId ? ticketId : event?.ReferenceGUID}`, "_blank");
        break;
      case 137:
        window.open(`/Ticket/Detail/${ticketId ? ticketId : event?.ReferenceGUID}`, "_blank");
        break;
      case 138:
        window.open(`/Announcement/Detail/${event?.ReferenceGUID}`, "_blank");
        break;
      case 139:
        window.open(`/Dashboard`, "_blank");
        break;
      case 140:
        window.open(`/Feed/Post/${event?.ReferenceGUID}`, "_blank");
        break;
      case 142:
        window.open(`/Feed/Post/${event?.ReferenceGUID}`, "_blank");
        break;
      case 143:
        window.open(`/Feed/Post/${event?.ReferenceGUID}`, "_blank");
        break;
      case 144:
        window.open(`/Dashboard`, "_blank");
        break;
      case 145:
        window.open(`/Feed/Post/${event?.ReferenceGUID}`, "_blank");
        break;
      default:
        console.warn("Unknown NotificationTypeId:", event?.NotificationTypeId);
        break;
    }
  };
  const handleImageError = useCallback((event) => {
    event.target.src = defaultImage;
  }, []);

  return (
    <div>
      <div className="container-fluid">
        <div className="form-head displayset">
          <div className="me-auto">
            <h2 className="font-w600 mb-0">Notifications</h2>
            <p className="text-light">{masterSystemAlertData}</p>
          </div>
          <div
            className="form-head d-grid  align-items-center"
            style={{ gridTemplateColumns: "1fr auto" }}
          >
            <div className="input-group search-area2 d-xl-inline-flex mt-0">
              <button className="input-group-text">
                <i className="fa fa-search text-primary"></i>
              </button>
              <input
                onChange={(event) => handleChange(event)}
                type="text"
                className="form-control"
                placeholder="Search here..."
              />
            </div>
            <button
              onClick={() => AllNotificationRead()}
              className="markasread"
            >
              Mark as all read
            </button>
          </div>
        </div>
        <div className="timeline-wrapper">
          <div className="timeline-header"></div>
          <div className="timeline-wrapper-inner">
            <div className="timeline-container">
              <InfiniteScroll
                dataLength={notificationsList?.length}
                next={() => {
                  if (!isFetching) setTimeout(() => notifications(false), 700);
                }}
                hasMore={hasMore}
                scrollableTarget="scrollableDiv"
              >
                {notificationsList?.map((el, I, arr) => {
                  const className = configClass[I % configClass.length];
                  const currentDate = moment(el?.CreatedDate).format(
                    "MMM DD YYYY"
                  );
                  const prevDate =
                    I > 0
                      ? moment(arr[I - 1]?.CreatedDate).format("MMM DD YYYY")
                      : null;
                  const showDate = currentDate !== prevDate;
                  return (
                    <div
                      className={`timeline-item ${el.IsRead ? "is-info" : "is-unread"
                        }`}
                      key={I}
                    >
                      {showDate ? (
                        <div className="date">
                          <span>{currentDate}</span>
                        </div>
                      ) : (
                        <>
                          <div className="date">
                            <span> </span>
                          </div>
                        </>
                      )}
                      <div className={`dot ${className}`}></div>
                      <div className="content-wrap">
                        <div className="content-box">
                          <div
                            className="status"
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              notificationsRead(el);
                              FunctionNavitageToPage(el);
                            }}
                          ></div>
                          <div
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              notificationsRead(el);
                              FunctionNavitageToPage(el);
                            }}
                            className="box-text"
                          >
                            <div
                              className="h-avatar"
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                notificationsRead(el);
                                FunctionNavitageToPage(el);
                              }}
                            >
                              <img
                                className="avatar"
                                src={el?.SenderProfilePic || defaultImage}
                                onError={handleImageError}
                                alt={el?.SenderProfilePic}
                                data-user-popover="6"
                                data-target="webuiPopover3"
                              />
                            </div>
                            <div className="meta-text">
                              <b>{el?.SenderName}</b>
                              <p>
                                {el?.NotificationBody} <a></a>
                              </p>
                              <span>
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  stroke-width="2"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  className="feather feather-clock"
                                >
                                  <circle cx="12" cy="12" r="10"></circle>
                                  <polyline points="12 6 12 12 16 14"></polyline>
                                </svg>
                                {moment(el?.CreatedDate).format("LT")}
                              </span>
                            </div>
                          </div>
                          <h4
                            className="notification-title"
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              notificationsRead(el);
                              FunctionNavitageToPage(el);
                            }}
                          >
                            {el?.NotificationTitle}
                          </h4>
                          <span
                            onClick={() => {
                              notificationsRemove(el);
                            }}
                            style={{ cursor: "pointer" }}
                            className=" me-1 remove "
                            data-toggle="tooltip"
                            data-placement="top"
                            title="Remove"
                            data-bs-original-title="Remove"
                            aria-label="Remove"
                            data-bs-toggle="modal"
                            data-bs-target="#award-popup"
                          >
                            <img
                              src="/images/tickets/delete.svg"
                              className="editdivinfo"
                            />
                          </span>
                        </div>
                      </div>
                    </div>
                  );
                })}
                {(!IsNotificationloading && notificationsList.length === 0) && (
                  <div className="notfound">
                    <img src="/images/no-data-found/Notification.png" />
                    <p>{noData}</p>
                  </div>
                )}
              </InfiniteScroll>
            </div>
          </div>
        </div>
        {IsNotificationloading ? (
          <Suspense>
            <ComponentLoader />
          </Suspense>
        ) : (
          ""
        )}
      </div>
    </div>
  );
}

export default Notification;
